export default function mod(n, x) {
    return ((n % x) + x) % x;
}



//////////////////
// WEBPACK FOOTER
// D:/Projects/MDA/schoolofmusic-ucla/web/app/themes/ucla/node_modules/moment/src/lib/utils/mod.js
// module id = 321
// module chunks = 0